import { commonConstant } from "../../../server/triage/constants";
import { checkAndGetLocalStorageValue,generateJsonWebToken,checkAndGetSessionStorageValue  } from "../../../features/utils";
import { defaultCovidUrl } from "client.config";

 export async function getGuidlines({ setState }) { 

    var countryName = checkAndGetLocalStorageValue("countryname");
    var cityName = checkAndGetLocalStorageValue("cityname");
    var provinceName = checkAndGetLocalStorageValue("statename");
    var countyName = checkAndGetLocalStorageValue("provincename");

    const fulllocation = cityName+","+provinceName +","+ countryName
    const organizationid = checkAndGetLocalStorageValue("orgid")
    window.store = store
    var jwtAccess_Token = generateJsonWebToken()
    var access_Token = checkAndGetSessionStorageValue("accessToken")
  

    var response = await actions.sendTriageRequest({
        action: "GetCovidSymptoms",
        data: {
            OrganizationId:organizationid,            
            jwtAccessToken : jwtAccess_Token,
            accessToken : access_Token,
            paramsDto:{
                TagsBooleanOperator: "and",
                Tags: ["COVID-19", "Local Details Url"],
                Type: "Url",
                CityName: cityName !== "" && (countryName == "United Kingdom" || countryName == "Canada") ? cityName : null,
                CountyName: countyName == "" || countryName != "United States" ? null : countyName,
                ProvinceName: provinceName == "" || countryName == "United Kingdom" ? null : provinceName,
                CountryName: countryName
            }
        }  
    });

    if (response && response.message === commonConstant.success) {
        var symptomsInfo = response.symptomsInfo;
        setState({
            GuidLinesInfo: symptomsInfo
            
        })         
            if(symptomsInfo.url == null)
            {
              localStorage.setItem("covidurl", defaultCovidUrl)
            } 
            else
            {     
              localStorage.setItem("covidurl",symptomsInfo.url)   
            }      
        localStorage.setItem("covidenabled",symptomsInfo.covidEnabled)    
    }
    
        localStorage.setItem("careoption","") 
} //covid change 